// extracted by mini-css-extract-plugin
export default {"dividerText":"FundingInformation_dividerText__6BScr"};